/* tslint:disable */
/* eslint-disable */
/**
 * My API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface DataFileDto
 */
export interface DataFileDto {
    /**
     * 
     * @type {string}
     * @memberof DataFileDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof DataFileDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof DataFileDto
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof DataFileDto
     */
    'parentId'?: string;
    /**
     * 
     * @type {string}
     * @memberof DataFileDto
     */
    'parentType'?: DataFileDtoParentTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof DataFileDto
     */
    'subType'?: DataFileDtoSubTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof DataFileDto
     */
    'version'?: number;
    /**
     * 
     * @type {string}
     * @memberof DataFileDto
     */
    'extension'?: string;
    /**
     * 
     * @type {number}
     * @memberof DataFileDto
     */
    'created'?: number;
    /**
     * 
     * @type {number}
     * @memberof DataFileDto
     */
    'updated'?: number;
    /**
     * 
     * @type {number}
     * @memberof DataFileDto
     */
    'fileSizeInBytes'?: number;
    /**
     * 
     * @type {number}
     * @memberof DataFileDto
     */
    'numberOfRows'?: number;
    /**
     * 
     * @type {number}
     * @memberof DataFileDto
     */
    'numberOfColumns'?: number;
}

export const DataFileDtoParentTypeEnum = {
    Entity: 'ENTITY',
    ScenarioStep: 'SCENARIO_STEP'
} as const;

export type DataFileDtoParentTypeEnum = typeof DataFileDtoParentTypeEnum[keyof typeof DataFileDtoParentTypeEnum];
export const DataFileDtoSubTypeEnum = {
    User: 'USER',
    Merged: 'MERGED',
    Ingress: 'INGRESS'
} as const;

export type DataFileDtoSubTypeEnum = typeof DataFileDtoSubTypeEnum[keyof typeof DataFileDtoSubTypeEnum];


